import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { selectedTemplateAtom } from '../../state';

export const useTemplateConfirmationDeps = () => {
  const navigate = useNavigate();
  const { checklistExternalId } = useParams();
  const selectedTemplate = useRecoilValue(selectedTemplateAtom);

  return {
    navigate,
    checklistExternalId,
    selectedTemplate,
  };
};
